import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function ManageTenantRolesDialog({
  title,
  values, // current values for updating fields
  data, // current Tenant Roles data
  contentMsg,
  closeDialog,
  addEditDialog,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState([]);
  const [textFieldValue, setTextFieldValue] = useState(values ? values : ["", ""]);
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleDone = textFieldValue => {
    // Validate Role name
    if (textFieldValue[0].trim() === "") {
      setErrorMsg("This is a required field");
      return;
    }
    // Control that the name of the Role is not repeated
    if (
      (values && values[0].toLowerCase() !== textFieldValue[0].toLowerCase()) ||
      !values
    ) {
      const findRoleIndex = data.findIndex(
        item => item.roleName.toLowerCase() === textFieldValue[0].toLowerCase()
      );
      if (findRoleIndex !== -1) {
        setErrorMsg("This role name already exists");
        return;
      }
    }
    setOpen(false);
    addEditDialog && addEditDialog(textFieldValue);
  };

  const handleTextFieldChange = (event, index) => {
    const newInputs = [...textFieldValue];
    newInputs[index] = event.target.value;
    setTextFieldValue(newInputs);
    if (index === 0 && event.target.value.trim() !== "") setErrorMsg("");
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            {title}
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          {contentMsg.map((cntMsg, index) => (
            <DialogContentText id="alert-dialog-description">
              <TextField
                //className={classes.textFieldStyle}
                fullWidth
                autoFocus={index == 0}
                label={cntMsg}
                margin="normal"
                name="name"
                variant="outlined"
                id="name"
                value={textFieldValue[index]}
                onChange={e => {
                  handleTextFieldChange(e, index);
                }}
                onKeyDown={e => {
                  e.key === "Enter" && handleDone(textFieldValue);
                }}
              />
              {errorMsg && index === 0 && (
                <Box ml={2}>
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg}
                  </FormHelperText>
                </Box>
              )}
            </DialogContentText>
          ))}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={() => handleDone(textFieldValue)}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
